const STORAGE_KEY = "tpv_screensaver_settings";

export const SCREENSAVER_CHANGED_EVENT = "agest-screensaver-changed";
export const SHOW_SCREENSAVER_EVENT = "agest-screensaver-show";

export const SCREENSAVER_DEFAULTS = {
  enabled: true,
  intervalMinutes: 5,
  backgroundColor: "#0f172a",
  imageUrl: "",
  message: "Toca la pantalla para volver",
  showClock: true,
};

function clampInterval(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return SCREENSAVER_DEFAULTS.intervalMinutes;
  return Math.min(120, Math.max(1, Math.round(parsed)));
}

function normalizeColor(value) {
  const color = typeof value === "string" ? value.trim() : "";
  if (/^#[0-9a-f]{6}$/i.test(color)) return color.toLowerCase();
  if (/^#[0-9a-f]{3}$/i.test(color)) {
    return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
  }
  return SCREENSAVER_DEFAULTS.backgroundColor;
}

export function normalizeScreensaverSettings(value) {
  return {
    ...SCREENSAVER_DEFAULTS,
    ...(value || {}),
    enabled: value?.enabled !== false,
    intervalMinutes: clampInterval(value?.intervalMinutes),
    backgroundColor: normalizeColor(value?.backgroundColor),
    imageUrl: typeof value?.imageUrl === "string" ? value.imageUrl.trim() : "",
    message:
      typeof value?.message === "string" && value.message.trim()
        ? value.message.trim()
        : SCREENSAVER_DEFAULTS.message,
    showClock: value?.showClock !== false,
  };
}

export function getScreensaverSettings() {
  try {
    return normalizeScreensaverSettings(
      JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"),
    );
  } catch {
    return { ...SCREENSAVER_DEFAULTS };
  }
}

export function saveScreensaverSettings(settings) {
  const normalized = normalizeScreensaverSettings(settings);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  window.dispatchEvent(new Event(SCREENSAVER_CHANGED_EVENT));
  return normalized;
}

export function notifyScreensaverSettingsChanged() {
  window.dispatchEvent(new Event(SCREENSAVER_CHANGED_EVENT));
}

export function requestScreensaverPreview(settings) {
  window.dispatchEvent(
    new CustomEvent(SHOW_SCREENSAVER_EVENT, {
      detail: settings
        ? normalizeScreensaverSettings(settings)
        : undefined,
    }),
  );
}
